import { Component, Input, OnInit } from '@angular/core';
import { EnrollmentAppStateStructure } from 'src/app/angular-elements/shared/interfaces/enrollmentAppStateStructure.interface';
import { ReducerUtilityService } from 'src/app/shared/utility-services/reducer-utility.service';
import { PrintButtonComponent } from '../../print-button.component';
import { PrintButtonService } from '../../services/print-button.service';
import { PRODUCT_GROUPS } from 'src/app/angular-elements/plan-selection/enums/product-groups.enum';
import { PRINT_TYPE } from '../../enums/print-type.enum';
import { APPLICANT_RELATION } from 'src/app/angular-elements/plan-selection/services/interfaces/shared/plan-demographics/applicant.interface';
//update submitted app print for sep online mn enrollment
@Component({
    selector: 'app-submitted-application-pdf-print',
    templateUrl: './../../print-button.component.html',
    styleUrls: ['./../../print-button.component.scss'],
    standalone: false
})
export class SubmittedApplicationPdfPrint extends PrintButtonComponent implements OnInit {

  @Input() printType: PRINT_TYPE;
  eApp: EnrollmentAppStateStructure;

  constructor(
    private reducerUtilityService: ReducerUtilityService,
    private printButtonService: PrintButtonService
  ) {
    super();
  }

  ngOnInit(): void {
    super.ngOnInit();
    
    this.eApp = this.printButtonService.getEnrollmentAppInfo();

    const extraInfo = this.eApp.extraInfo;

    if (this.printType === PRINT_TYPE.DOMESTIC_PARTNER_ATTESTATION) {
      /** HIDE this button when it is ONLY for Domestic Partner relation and such a relation does not exist */
      this.showButton = extraInfo.spouseRelation === APPLICANT_RELATION.DOMESTIC_PARTNER;
    }
  }

  async onPrintPage(): Promise<void> { //overwrite call for print button component //regular print-button.component.ts just calls window.print() 
    this.printButtonService.triggerPrintPdf(this.eApp, this.printType);
  }
}
